<div class="perfil-container w-full ps-9">
    <div class="avatar-wrapper">
        <img src="../../../../assets/avatar.png" alt="Foto de perfil" class="avatar" />
        <button mat-icon-button class="edit-button" (click)="openEditAvatarDialog()">
        <mat-icon>edit</mat-icon>
        </button>
    </div>
    <div class="user-info">
        <h3>{{ usuario.nombre }}</h3>
        <p>{{ usuario.empresa }}</p>
    </div>
</div>